import * as actionTypes from '../../constants/actionTypes';

export const signIn = () => ({
  type: actionTypes.AUTH_SIGN_IN,
});

export const signOut = () => ({
  type: actionTypes.AUTH_SIGN_OUT,
});

export const signInFailed = (errors) => ({
  type: actionTypes.AUTH_SIGN_IN_FAILED,
  errors,
});

// thunks
export const doSignIn = ({ email, password }) => async (dispatch) => {
  try {
    await fetch(`${process.env.REACT_APP_API_ROOT}/jwt/token/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.refresh && data.access){
          localStorage.setItem('refresh', data.refresh);
          localStorage.setItem('access', data.access);
          return dispatch(signIn());
        }
        return dispatch(signInFailed(data));
      });
  } catch (e) {
    throw new Error();
  }
};

export const doSignOut = () => (dispatch) => {
  dispatch(signOut());
};
